import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { User } from 'src/app/modals/Authentication/auth.models';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { fetchRecords } from './payment-type.action';

@Injectable({ providedIn: 'root' })
export class PaymentTypeTableService {

    constructor(
        private store: Store<RootReducerState>,
    ) { }
 
    pagination = [];
    filters = {
                created_at: '', 
                type_name: ''
            };


    page: number = 1;
    lastPage: number;
    limit: number = 10;
    initialSortColumn = 'created_at';
    initialSortDirection = 'desc';
    sortColumn = this.initialSortColumn;
    sortDirection = this.initialSortDirection;
    hasFilter = false;
    associations = [];
    columns = [
                { prop: 'created_at', name: 'COMMON.created-date', sortable: true, hasFilter: true, filter: "date", widthSet: 180},
                { prop: 'type_name', name: 'PAYMENT_TYPE.type-name', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'actions', name: 'COMMON.actions', sortable: false, hasFilter: false, filter: ""}
            ];

    loadRecords() {
        this.hasFilter = this.hasActiveFilters();
        this.store.dispatch(fetchRecords());
    }

    hasActiveFilters(){

        if(
            (Object.values(this.filters).some(value => value !== '' && value !== null)) ||
            (this.sortDirection !== this.initialSortDirection || this.sortColumn !== this.initialSortColumn)
        )
            return true;
        else
            return false;        
    }

    resetFilters(){
        this.filters = {
            created_at: '', 
            type_name: ''
        }

        this.sortDirection = this.initialSortDirection;
        this.sortColumn = this.initialSortColumn;

        this.loadRecords();
    }

}